import { apiCall, apiPrefix } from "@services/API/Requests";

export const getContactHistory = async (
  setContactHistoryData: (data: any) => void,
  setLoading: (loading: boolean) => void,
  setError: (error: any) => void,
  userId: string,
  useToken = false,
) => {
  return apiCall({
    method: "get",
    url: `${apiPrefix}/contact_history/show_all_for_user/${userId}`,
    useToken,
    setLoading,
    onSuccess: (response) => {
      setContactHistoryData(response.data);
    },
    onError: (errorResponse) => {
      console.warn(errorResponse);
      // setError(errorResponse);
    },
  });
};
